import styled from "styled-components";

export const ViewReportWrapper = styled.div`
  font: normal normal 600 16px/23px Montserrat;
`;

export const AnotherWraper = styled.div``;
